// import React, { useState, useEffect } from 'react';
// import { Table, Form, Button } from 'react-bootstrap';
// import Navbar from '../../Components/Navbar';

// export default function ReviewerDocument() {
//   const [applications, setApplications] = useState([]);

//   // Simulate fetching application IDs from a database
//   useEffect(() => {
//     const mockApplications = [
//       { id: 'APP001' },
//       { id: 'APP002' },
//       { id: 'APP003' },
//     ];
//     setApplications(mockApplications.map(app => ({
//       ...app,
//       reviewer: '',
//       file: null,
//       marks: '',
//     })));
//   }, []);

//   const handleReviewerChange = (index, value) => {
//     const updated = [...applications];
//     updated[index].reviewer = value;
//     setApplications(updated);
//   };

//   const handleFileChange = (index, file) => {
//     const updated = [...applications];
//     updated[index].file = file;
//     setApplications(updated);
//   };

//   const handleMarksChange = (index, value) => {
//     const updated = [...applications];
//     updated[index].marks = value;
//     setApplications(updated);
//   };

//   const handleUpload = (index) => {
//     const app = applications[index];
//     console.log('Uploading...', {
//       reviewer: app.reviewer,
//       appId: app.id,
//       file: app.file,
//       marks: app.marks,
//     });
//     alert(`Uploaded for Application ID: ${app.id}`);
//   };

//   return (
//     <div>
//       <Navbar />
//       <h1 className="page-title">Application Evaluation</h1>
//       <Table striped bordered hover style={{ marginTop: '20px', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)' }}>
//         <thead>
//           <tr>
//             <th>Reviewer</th>
//             <th>Application ID</th>
//             <th>Evaluation Report</th>
//             <th>Marks</th>
//             <th>Upload</th>
//           </tr>
//         </thead>
//         <tbody>
//           {applications.map((app, index) => (
//             <tr key={app.id}>
//               <td>
//                 <Form.Select
//                   value={app.reviewer}
//                   onChange={(e) => handleReviewerChange(index, e.target.value)}
//                 >
//                   <option value="">Select Reviewer</option>
//                   <option value="Reviewer One">Reviewer One</option>
//                   <option value="Reviewer Two">Reviewer Two</option>
//                   <option value="Reviewer Three">Reviewer Three</option>
//                 </Form.Select>
//               </td>
//               <td>{app.id}</td>
//               <td>
//                 <Form.Control
//                   type="file"
//                   onChange={(e) => handleFileChange(index, e.target.files[0])}
//                 />
//               </td>
//               <td>
//                 <Form.Control
//                   type="number"
//                   placeholder="Enter Marks"
//                   value={app.marks}
//                   onChange={(e) => handleMarksChange(index, e.target.value)}
//                 />
//               </td>
//               <td>
//                 <Button variant="primary" onClick={() => handleUpload(index)}>
//                   Upload
//                 </Button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </Table>
//     </div>
//   );
// }

import React, { useState } from 'react';
import { Table, Button, Form } from 'react-bootstrap';
import Navbar from '../../Components/Navbar';
import '../Secretary/Table.css';
import { API_BASE_URL } from '../../config';

export default function ReviewerDocument() {
  const [rows, setRows] = useState([
    { appId: '', reviewer: '', file: null, marks: '' },
  ]);

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const handleFileChange = (index, event) => {
    const updatedRows = [...rows];
    updatedRows[index].file = event.target.files[0];
    setRows(updatedRows);
  };

 const handleUpload = async (index) => {
  const { appId, reviewer, file, marks } = rows[index];

  if (!appId || !reviewer || !file || !marks) {
    alert('Please fill in all fields before uploading.');
    return;
  }

  const formData = new FormData();
  formData.append('app_ID', appId);
  formData.append('overallMarks', marks);
  formData.append('reviewer', reviewer);
  formData.append('evaluationReport', file);

  try {
    const response = await fetch(`${API_BASE_URL}/ReviewerDocuments.php`, {
      method: 'POST',
      body: formData,
    });

    const result = await response.json();
    alert(result.message);

    if (result.status === "success") {
      // Clear the uploaded row after successful upload
      const updatedRows = [...rows];
      updatedRows[index] = { appId: '', reviewer: '', file: null, marks: '' };
      setRows(updatedRows);
    }
  } catch (error) {
    console.error('Upload failed', error);
    alert('Upload failed.');
  }
};

 
  return (
    <div>
      <Navbar />
      <h1 className="page-title">Upload Reviewer Documents & Marks</h1>
      {/* <Button onClick={addRow} style={{ marginBottom: '10px' }}>Add Row</Button> */}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Reviewer</th>
            <th>Application ID</th>
            <th>Evaluation Report</th>
            <th>Marks</th>
            <th>Upload</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td>
                <Form.Select
                  value={row.reviewer}
                  onChange={(e) => handleChange(index, 'reviewer', e.target.value)}
                >
                  <option value="">Select Reviewer</option>
                  <option value="Reviewer One">Reviewer One</option>
                  <option value="Reviewer Two">Reviewer Two</option>
                  <option value="Reviewer Three">Reviewer Three</option>
                </Form.Select>
              </td>
              <td>
                <Form.Control
                  type="text"
                  placeholder="Enter Application ID"
                  value={row.appId}
                  onChange={(e) => handleChange(index, 'appId', e.target.value)}
                />
              </td>
              <td>
                <Form.Control
                  type="file"
                  onChange={(e) => handleFileChange(index, e)}
                />
              </td>
              <td>
                <Form.Control
                  type="number"
                  placeholder="Enter Marks"
                  value={row.marks}
                  onChange={(e) => handleChange(index, 'marks', e.target.value)}
                />
              </td>
              <td>
                <Button className='view-button' onClick={() => handleUpload(index)}>Upload</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
